import template from './view-cart-items.html';
import controller from './view-cart-items.controller';

let viewCartItemsComponent = {
    restrict: 'E',
    bindings: {
        cart: '=',
        shoppingCartForm: '=',
        canViewQuotePrices: '<'
    },
    template,
    controller
};

export default viewCartItemsComponent;


// WEBPACK FOOTER //
// ./src/app/components/view-cart/view-cart-items/view-cart-items.component.js